// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"17d49d2e","498":"08e1e2c8","598":"cb48adb7"}[chunkId] + ".chunk.js";
};